import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 22",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m5.75 16.249 10.5-10.5m-8.515 4.272a4.472 4.472 0 0 0-3.417 1.3l-2.25 2.25a4.5 4.5 0 0 0 6.364 6.364l2.25-2.25a4.472 4.472 0 0 0 1.3-3.417m2.283-2.292a4.473 4.473 0 0 0 3.417-1.3l2.25-2.25a4.5 4.5 0 1 0-6.364-6.364l-2.25 2.25a4.475 4.475 0 0 0-1.295 3.417",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2022%2022%22%3E%3Cpath%20d%3D%22m5.75%2016.249%2010.5-10.5m-8.515%204.272a4.472%204.472%200%200%200-3.417%201.3l-2.25%202.25a4.5%204.5%200%200%200%206.364%206.364l2.25-2.25a4.472%204.472%200%200%200%201.3-3.417m2.283-2.292a4.473%204.473%200%200%200%203.417-1.3l2.25-2.25a4.5%204.5%200%201%200-6.364-6.364l-2.25%202.25a4.475%204.475%200%200%200-1.295%203.417%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
